import * as fabric from 'office-ui-fabric-react';
import { FC } from 'react';
import { KendoLoading } from '../../../../../components';
import { ISettings } from '../GeneralSettingsPage';
import { GeneralSettingsUsersWarningOfDevices } from './devices/GeneralSettingsUsersWarningOfDevices';
import GeneralSettingsUsersWarningOfWaitingTimes from './waitingTimes/GeneralSettingsUsersWarningOfWaitingTimes';

interface IProps {
    settings: ISettings | null;
    fetchData: () => Promise<void>;
}

const GeneralSettingsUsersWarning: FC<IProps> = (props) => {
    return (
        <>
            {!props.settings && <KendoLoading />}
            {props.settings && (
                <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row">
                        <div style={{ textAlign: 'center', padding: '10px' }} className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                            <fabric.Text style={{ fontWeight: 'lighter' }} variant="xLarge">
                                Įspėjimas nustojus veikti įrangai
                            </fabric.Text>
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <GeneralSettingsUsersWarningOfDevices fetchData={props.fetchData} settings={props.settings} />
                    </div>
                    <div className="ms-Grid-row">
                        <div style={{ textAlign: 'center', padding: '10px' }} className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                            <fabric.Text style={{ fontWeight: 'lighter' }} variant="xLarge">
                                Įspėjimas viršijus kritinius laikus
                            </fabric.Text>
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <GeneralSettingsUsersWarningOfWaitingTimes fetchData={props.fetchData} settings={props.settings} />
                    </div>
                </div>
            )}
        </>
    );
};

export default GeneralSettingsUsersWarning;
